import { z } from 'zod'
import {
  ProductCatalogueAccessConfigBaseSchema,
  ProductCatalogueAccessTypeSchema,
  ProductCatalogueAccessType,
} from '@omnea-app/packages/universal/form/elements/productCatalogueAccess'
import { AssigneeSchema } from '@omnea-app/packages/universal/requests/assignee'

export const CatalogueEntrySchema = z.object({
  ...ProductCatalogueAccessConfigBaseSchema.shape,
  accessApprover: AssigneeSchema.nullable(),
  accessUrl: z.string(),
  accessType: z.string().nullable(),
})

export const CustomProductBrandSchema = z.object({
  customProductDescription: z.string().nullable(),
  customProductSelectedSupplierBrand: z
    .object({
      id: z.string().nullable(),
      name: z.string(),
      logoUrl: z.string().nullable(),
      globalSupplierId: z.string().nullable(),
    })
    .refine((data) => data.id === null || data.globalSupplierId !== null, {
      message: 'If the supplier brand id is null, globalSupplierId must be defined',
    })
    .nullable(),
})

type CustomProductBrand = z.infer<typeof CustomProductBrandSchema>
export type SupplierSelection = NonNullable<CustomProductBrand['customProductSelectedSupplierBrand']>

export const AddProductCatalogueEntryFormSchema = z
  .object({ ...CatalogueEntrySchema.shape, ...CustomProductBrandSchema.shape })
  .extend({
    selectedProductBrand: z
      .object({
        isGlobalProduct: z.boolean(),
        id: z.string(),
        name: z.string(),
        logoUrl: z.string().nullable(),
        description: z.string().nullable(),
        organisationProductId: z.uuid().nullable(),
        supplier: z.object({
          id: z.string(),
          name: z.string(),
          logoUrl: z.string().nullable(),
          supplierBrandId: z.string().nullable(),
        }),
        categoryIds: z.array(z.uuid()),
      })
      .nullable(),
  })

export type ProductBrandForm = z.infer<typeof AddProductCatalogueEntryFormSchema>

export const AccessTypeSchema = ProductCatalogueAccessTypeSchema
export type AccessType = z.infer<typeof AccessTypeSchema>
export const isProductCatalogueAccessType = (value: unknown): value is ProductCatalogueAccessType => {
  return AccessTypeSchema.safeParse(value).success
}
